import { render, staticRenderFns } from "./OkexSwapUsdtMarketPrice.vue?vue&type=template&id=5e87dd26&"
import script from "./OkexSwapUsdtMarketPrice.vue?vue&type=script&lang=js&"
export * from "./OkexSwapUsdtMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports